import React from 'react';
import { Badge, Card, Table } from 'react-bootstrap';
import { WinTimeImportResponse } from '../../../common/api/dac7Service';

type WinTimeImportsTableProps = {
  winTimeImports: WinTimeImportResponse[];
  formatDate: (dateString: string) => string;
  getImportStatusBadge: (status: string) => React.ReactNode;
};

function WinTimeImportsTable({
  winTimeImports,
  formatDate,
  getImportStatusBadge,
}: WinTimeImportsTableProps) {
  return (
    <Card className="bg-white border shadow-none p-24 mb-24">
      <h5 className="mb-16">Tuodut WinTime-tiedostot</h5>
      <Table striped hover responsive>
        <thead>
          <tr>
            <th>Tiedosto</th>
            <th>Tuotu</th>
            <th>Tuoja</th>
            <th>Rivejä</th>
            <th>Käsitelty</th>
            <th>Importin tila</th>
          </tr>
        </thead>
        <tbody>
          {winTimeImports.map(importItem => (
            <tr key={importItem.id}>
              <td>{importItem.fileName}</td>
              <td>{formatDate(importItem.importedAt)}</td>
              <td>{importItem.importedBy}</td>
              <td>
                {importItem.totalRows}
                {importItem.errorRows > 0 && (
                  <span className="text-danger ms-2">
                    ({importItem.errorRows} virheellistä)
                  </span>
                )}
              </td>
              <td>
                {importItem.processedRows} / {importItem.totalRows}
                {importItem.totalRows - importItem.processedRows > 0 && (
                  <Badge bg="warning" className="ms-2">
                    {importItem.totalRows - importItem.processedRows} odottaa
                  </Badge>
                )}
              </td>
              <td>{getImportStatusBadge(importItem.status)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
}

export default WinTimeImportsTable;
